import { Popover } from "antd";
import apiFactory from "api";
import nursingCareRecordApi from "api/admin/nursingCareRecord";
import { ButtonSolid } from "component/button";
import { MONTH_FORMAT } from "constant/date";
import { Dayjs } from "dayjs";
import usePrint from "hook/usePrint";
import { isEmpty } from "lodash";
import PrintPdfNursingCareRecord from "page/admin/NursingCareRecord/components/PrintPdfNursingCareRecord";
import ModalPrintServicePDF from "page/admin/NursingCareRecordDetail/components/ModalPrintServicePDF";
import ModalReceiptAmountPrintPDF from "page/admin/NursingCareRecordDetail/components/ModalReceiptAmountPrintPDF";
import ServiceProvisionRecord from "page/admin/NursingCareRecordDetail/components/PDFs/ServiceProvisionRecord";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store";
import { IItemService, IServiceType } from "types/admin";
interface IProps {
  nurseId?: number | string | "";
  patientId?: number | "";
  tab?: "staff" | "patient";
  clientIdsObj: {
    [key: string]: {
      checked: boolean;
      clientId: number;
      isDisability: boolean;
    };
  };
  currentDate?: Dayjs;
}

const GroupPDFs = (props: IProps) => {
  const { clientIdsObj, currentDate, patientId, tab } = props;
  const [modePrint, setModePrint] = useState<"portrait" | "landscape">(
    "portrait"
  );

  const [printing, setPrinting] = useState(false); // set state printing  for ServiceProvisionRecord btn 居宅介護サービス提供実績記録票
  const [dataPrint, setDataPrint] = useState<IItemService[]>([]); // set data print for ServiceProvisionRecord btn 居宅介護サービス提供実績記録票
  const [isReadyPrint, setIsReadyPrint] = useState(false); // set data print for ServiceProvisionRecord btn 居宅介護サービス提供実績記録票
  const [serviceTypes, setServiceTypes] = useState<IServiceType[]>([]); // set data print for ServiceProvisionRecord btn 居宅介護サービス提供実績記録票
  const [preventAction, setPreventAction] = useState(false);
  const user = useSelector((state: RootState) => state.user);

  const [isOpenBtnsPdf, setIsOpenBtnsPdf] = useState(false);

  // State for histories patient pdf
  const [isHistoryPrinting, setIsHistoryPrinting] = useState(false);
  const [paramsHistory, setParamsHistory] = useState<{
    patientId: number | "";
    nurseId: number | "";
    id: number | "";
    isGetAll?: boolean;
  } | null>(null);

  const { ref, handlePrint } = usePrint(true, {
    onBeforeGetContent: () => {
      setPrinting(false);
    },
    onAfterPrint: () => {
      setPreventAction(false);
    },
  });
  const listPdfHasIsDisability = Object.values(clientIdsObj).some(
    (x) => x.isDisability
  );
  const [modalPDF, setModalPDF] = useState<{
    type: "service" | "notificationOfAmountReceived";
    open: boolean;
  } | null>(null);

  const handlePrintServiceProvisionRecord = async () => {
    const year_month = currentDate?.format(MONTH_FORMAT);
    if (!clientIdsObj) return;
    setPrinting(true);
    setPreventAction(true);

    const checkIdExisted: any = {};
    const client_ids = Object.values(clientIdsObj).reduce((acc, cur) => {
      if (checkIdExisted[cur.clientId]) return acc;
      acc.push(cur.clientId);
      checkIdExisted[cur.clientId] = true;
      return acc;
    }, [] as number[]);

    const param = {
      per: "10000",
    };

    const promiseDataPrint =
      apiFactory.adminNursingCareRecordApi.pdfServiceDelivery({
        year_month,
        client_ids,
        care_plan_type: "DisabilityCarePlan",
      });
    const promiseServiceTypes = await nursingCareRecordApi.getServiceType(
      "",
      param,
      user?.role
    );
    Promise.all([promiseDataPrint, promiseServiceTypes])
      .then((result) => {
        const [dataPrint, dataServiceTypes] = result;
        const data = dataPrint.data as IItemService[];
        const serviceTypes =
          dataServiceTypes.serialized_service_types as IServiceType[];
        setServiceTypes(serviceTypes);
        setDataPrint(data);
      })
      .catch((err) => console.log(err));
  };

  const buttonPdfs = (
    <div className="ignone_popup_pdf">
      <ButtonSolid
        onClick={() => {
          if (preventAction) return;
          setModePrint("portrait");
          setParamsHistory({
            patientId: "",
            nurseId: "",
            id: "",
          });
          setIsHistoryPrinting(true);
        }}
        className="h-10 w-[244px] !rounded-sm border !font-medium mb-3"
        isLoading={isHistoryPrinting && !paramsHistory?.id}
        isDisabled={printing}
      >
        介護記録の一括出力
      </ButtonSolid>
      <br />

      {listPdfHasIsDisability && (
        <>
          <ButtonSolid
            onClick={() => {
              if (preventAction) return;
              setModePrint("portrait");
              setModalPDF({
                type: "notificationOfAmountReceived",
                open: true,
              });
            }}
            className="h-10 w-[244px] !rounded-sm border !font-medium mb-2"
            isDisabled={
              isEmpty(clientIdsObj) ||
              printing ||
              (isHistoryPrinting && !paramsHistory?.id)
            }
          >
            代理受領額通知書
          </ButtonSolid>
          <br />
        </>
      )}
      <ButtonSolid
        onClick={() => {
          if (preventAction) return;
          setModePrint("landscape");
          setModalPDF({
            type: "service",
            open: true,
          });
        }}
        className="h-10 w-[244px] !rounded-sm border !font-medium mb-2"
        isDisabled={
          isEmpty(clientIdsObj) ||
          printing ||
          (isHistoryPrinting && !paramsHistory?.id)
        }
      >
        サービス提供表
      </ButtonSolid>
      <br />
      <ButtonSolid
        onClick={() => {
          if (preventAction) return;
          handlePrintServiceProvisionRecord();
          setModePrint("portrait");
        }}
        className="h-10 w-[244px] !rounded-sm border !font-medium mb-3"
        isDisabled={
          isEmpty(clientIdsObj) || (isHistoryPrinting && !paramsHistory?.id)
        }
        isLoading={printing}
      >
        居宅介護サービス提供実績記録票
      </ButtonSolid>
    </div>
  );

  useEffect(() => {
    const handleSetOpenPopupBtnsPdf = (e: MouseEvent) => {
      if (!(e.target as HTMLElement).closest(".ignone_popup_pdf")) {
        setIsOpenBtnsPdf(false);
      }
    };
    document.addEventListener("mousedown", handleSetOpenPopupBtnsPdf);
    return () => {
      document.removeEventListener("mousedown", handleSetOpenPopupBtnsPdf);
    };
  });

  useEffect(() => {
    if (isReadyPrint) {
      setIsReadyPrint(false);
      setDataPrint([]);
      handlePrint();
    }
  }, [isReadyPrint]);

  return (
    <div>
      <style>
        {`
            @media print {
              @page {
                size: ${modePrint};
                padding:6mm
              }
              .break-inside {
                break-inside: avoid;
              }
            }
            `}
      </style>
      <Popover
        placement="leftTop"
        trigger={"click"}
        title={""}
        content={buttonPdfs}
        open={isOpenBtnsPdf}
      >
        <ButtonSolid
          className="ignone_popup_pdf"
          onClick={() => {
            setIsOpenBtnsPdf(!isOpenBtnsPdf);
          }}
        >
          PDF出力
        </ButtonSolid>
      </Popover>

      {paramsHistory && (
        <PrintPdfNursingCareRecord
          setParamsHistory={setParamsHistory}
          patientId={patientId || ""}
          setIsPrinting={setIsHistoryPrinting}
          currentDate={currentDate}
          tab={tab}
        />
      )}
      <ModalReceiptAmountPrintPDF
        currentDate={currentDate}
        clientIdsObj={clientIdsObj}
        open={
          !!modalPDF?.open && modalPDF.type === "notificationOfAmountReceived"
        }
        setModalPDF={setModalPDF}
        onCancel={() => {
          setModalPDF(null);
        }}
      />
      <ModalPrintServicePDF
        currentDate={currentDate}
        clientIdsObj={clientIdsObj}
        open={!!modalPDF?.open && modalPDF.type === "service"}
        setModalPDF={setModalPDF}
        onCancel={() => {
          setModalPDF(null);
        }}
      />

      {dataPrint.length > 0 && (
        <ServiceProvisionRecord
          dataPrint={dataPrint}
          setIsReadyPrint={setIsReadyPrint}
          currentDate={currentDate}
          serviceTypes={serviceTypes}
          ref={ref}
        />
      )}
    </div>
  );
};

export default GroupPDFs;
